import Slide from "./Slide.js";
function Header() {
  return (
    <header>
      <Slide />
      <h1>
         The Best App To Keep Track Of All Your
        Games!!!
      </h1>
      <Slide />
    </header>
  );
}
export default Header;
